function LoginArtWork () {
    return (<>
        <svg
          className="arta-login-network-art"
          viewBox="0 0 640 250"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden="true"
        >
          <path
            className="arta-network-line arta-network-blue"
            d="M20 188 C120 188 124 72 230 72 S338 164 430 164 520 74 620 74"
          />

          <path
            className="arta-network-line arta-network-yellow"
            d="M20 214 C146 214 150 126 272 126 S410 214 620 214"
          />

          <circle
            className="arta-network-node arta-network-red"
            cx="20"
            cy="188"
            r="8"
          />

          <circle
            className="arta-network-node arta-network-blue-fill"
            cx="230"
            cy="72"
            r="10"
          />

          <circle
            className="arta-network-node arta-network-green"
            cx="430"
            cy="164"
            r="8"
          />

          <circle
            className="arta-network-node arta-network-yellow-fill"
            cx="620"
            cy="74"
            r="10"
          />
        </svg>
    </>)
}

export default LoginArtWork